import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { authApi } from "../features/auth/authApi.js";
import { useConnectionStore } from "../state/connectionStore.js";
import { Link, ROUTES } from "./router/index.js";

export function MainNavigation() {
  const { t } = useTranslation();
  const status = useConnectionStore((state) => state.status);
  const [canManageThemes, setCanManageThemes] = useState(false);

  useEffect(() => {
    let active = true;
    const refreshAccess = async () => {
      if (active) setCanManageThemes(false);
      if (status !== "connected") return;
      try {
        const access = await authApi.access();
        if (active) setCanManageThemes(access.permissions.includes("themes.manage"));
      } catch {
        if (active) setCanManageThemes(false);
      }
    };
    void refreshAccess();
    const onFocus = () => void refreshAccess();
    window.addEventListener("focus", onFocus);
    return () => {
      active = false;
      window.removeEventListener("focus", onFocus);
    };
  }, [status]);

  return (
    <nav aria-label={t("nav.label")} className="flex flex-wrap gap-3 text-sm">
      <Link to={ROUTES.game} className="cx-nav-link">
        {t("nav.game")}
      </Link>
      <Link to={ROUTES.provablyFair} className="cx-nav-link">
        {t("nav.provablyFair")}
      </Link>
      <Link to={ROUTES.howToPlay} className="cx-nav-link">
        {t("nav.howToPlay")}
      </Link>
      {canManageThemes ? (
        <Link to={ROUTES.adminThemes} className="cx-nav-link">
          {t("nav.adminThemes")}
        </Link>
      ) : null}
    </nav>
  );
}
